import { Text, Anchor } from "@mantine/core";

/**
 * Tap-to-call for a client contact's flat phone field (distinct from the candidate phoneNumbers[]
 * model that ContactActions handles). Renders "Label: <number>" with the number as a `tel:` link.
 * stopPropagation is baked in so a tap inside a click-through card places the call rather than
 * navigating.
 */
export default function TelLink({ label, value, size = "xs", c = "dimmed" }) {
  if (!value) return null;
  return (
    <Text size={size} c={c}>
      {label}: {" "}
      <Anchor
        href={`tel:${value}`}
        onClick={(e) => e.stopPropagation()}
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        {value}
      </Anchor>
    </Text>
  );
}
